import { useEffect, useState } from 'react';

import axios from 'axios';
import { createContainer } from 'unstated-next';

import { VALIDATE_EMAIL } from '../../config/apiPaths';
import { getUrlParam, getUrls } from '../../utils/url';

const useValidateEmailContainer = () => {
    const [isValidToken, setIsValidToken] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    /**
     * In the background, check to see if the token in
     * the url for the email is valid.
     */
    useEffect(() => {
        const email = getUrlParam('email');
        const token = getUrlParam('token');

        if (!email || !token) {
            console.error('No email or token', { email, token });
            return;
        }

        const verify = async () => {
            setIsLoading(true);

            const { api } = getUrls();

            try {
                const url = `${api}${VALIDATE_EMAIL}`;
                console.debug('Validating email', { url, email, token });
                await axios.get(url, { params: { email, token } });

                setIsValidToken(true);
            } catch (err: any) {
                setIsValidToken(false);
            }

            setIsLoading(false);
        };

        verify();
    }, []);

    return {
        isValidToken,
        isLoading
    };
};

const ValidateEmailContainer = createContainer(useValidateEmailContainer);

export default ValidateEmailContainer;
